import React from 'react'
import PropTypes from 'prop-types'
import Head from 'next/head'
import DOMPurify from 'isomorphic-dompurify'
import { hidePageLoader } from '../../utils/page-loader'

export class HeadLayout extends React.Component {
  componentDidMount () {
    hidePageLoader()
  }

  static async getInitialProps ({ req }) {
    const nreum = req
      ? req.nreum.replace('<script type=\'text/javascript\' >', '').replace('</script>', '')
      : '<script src="/apm/nr.min.js"></script>'
    return { nreum }
  }

  render () {
    return (
      <Head>
        <meta charSet='utf-8' />
        <meta httpEquiv='X-UA-Compatible' content='IE=edge' />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <style type='text/css' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`body:before {
      position: fixed;
      display: block;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 10000;
      content: "";
      background: #fff url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBzdHJva2U9IiNlOTUxMGUiPiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSIgc3Ryb2tlLXdpZHRoPSIyIj4gICAgICAgICAgICA8Y2lyY2xlIHN0cm9rZS1vcGFjaXR5PSIuMiIgY3g9IjE4IiBjeT0iMTgiIHI9IjE4Ii8+ICAgICAgICAgICAgPHBhdGggZD0iTTM2IDE4YzAtOS45NC04LjA2LTE4LTE4LTE4Ij4gICAgICAgICAgICAgICAgPGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGZyb209IjAgMTggMTgiIHRvPSIzNjAgMTggMTgiIGR1cj0iMXMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIi8+ICAgICAgICAgICAgPC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+) center center no-repeat;
    }`) }} />
        <script type='text/javascript'>{this.props.nreum}</script>
        <link rel='shortcut icon' href='/static/favicons/favicon.ico' />
        <title>Advanced - Business Tax Portal - {this.props.title}</title>
        <link
          rel='stylesheet'
          href='https://unpkg.com/react-table@latest/react-table.css'
        />
        {this.props.children}
        <link rel='shortcut icon' href='/static/favicons/favicon.ico' />
        <meta name='apple-mobile-web-app-capable' content='yes' />
        <meta name='apple-mobile-web-app-status-bar-style' content='black-translucent' />
        <meta name='apple-mobile-web-app-title' content='Business Tax Portal' />
        <meta name='application-name' content='Business Tax Portal' />
        <meta name='mobile-web-app-capable' content='yes' />
        <meta name='theme-color' content='#fff' />
      </Head>
    )
  }
}

HeadLayout.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  nreum: PropTypes.string
}
